import ResourceList from './List';
import Create from './Create';
import Edit from './Edit';

const resource = {
    list: ResourceList,
    create: Create,
    edit: Edit,
};

export default resource;